import { H2 } from '@/common/ui'
import { APPLICATION_COPY, ONBOARDING_COPY } from '@/locales/en'

type Props = {
    isAdviser: boolean
}

export function AddAccountTermsAndConditionsStep({ isAdviser }: Props) {
    return (
        <div className="self-stretch inline-flex flex-col justify-start items-start">
            <div className="self-stretch flex flex-col justify-start items-start gap-12">
                <div className="self-stretch flex flex-col justify-start items-start gap-4">
                    <div className="self-stretch flex flex-col justify-start items-start gap-4">
                        <H2 className="self-stretch justify-start text-brand-forest text-3xl font-normal font-['Serious Sans'] leading-10 mb-0">
                            {APPLICATION_COPY.termsAndConditions.title}
                        </H2>
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-6">
                        {isAdviser && (
                            <div className="self-stretch inline-flex justify-start items-start gap-2">
                                <div className="flex-1 justify-start text-[#223A32] text-base font-normal font-['Inter'] leading-6">
                                    {APPLICATION_COPY.termsAndConditions.authorityStatement}
                                </div>
                            </div>
                        )}
                        <div className="self-stretch justify-start text-[#737671] text-base font-normal font-['Inter'] leading-6">
                            {isAdviser
                                ? APPLICATION_COPY.termsAndConditions.agreementStatement
                                : ONBOARDING_COPY.termsAndConditions.agreementText}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
